/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_DescriptionInputs */

const en_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To delete your Brave Premium account, click the link below and then follow the prompts to complete the process.`)
};

const id_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk menghapus akun Brave Premium Anda, klik tautan di bawah ini lalu ikuti petunjuk untuk menyelesaikan prosesnya.`)
};

const ms_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk memadam akaun Brave Premium anda, klik pautan di bawah, kemudian ikuti arahan untuk melengkapkan proses.`)
};

const ca_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per eliminar el teu compte de Brave Premium, fes clic a l'enllaç que veuràs a continuació i segueix les indicacions per completar el procés.`)
};

const cs_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chcete-li svůj účet Brave Premium odstranit, klikněte na níže uvedený odkaz a postupujte podle pokynů k dokončení procesu.`)
};

const da_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For at slette din Brave Premium-konto skal du klikke på linket nedenfor og derefter følge anvisningerne for at fuldføre processen.`)
};

const de_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du dein Brave Premium-Konto löschen willst, klicke auf den nachstehenden Link und folge den Anweisungen, um den Vorgang abzuschließen.`)
};

const et_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave'i tasulise konto kustutamiseks klõpsake alloleval lingil ja järgige seejärel juhiseid, et protsess lõpule viia.`)
};

const es_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para eliminar tu cuenta de Brave Premium, haz clic en el enlace abajo y sigue las instrucciones.`)
};

const fr_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour supprimer votre compte Brave Premium, cliquez sur le lien ci-dessous et suivez les instructions.`)
};

const hr_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kako biste izbrisali svoj račun Brave Premium, kliknite na poveznicu ispod i zatim slijedite upute kako biste završili proces.`)
};

const it_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per eliminare il tuo account Brave Premium, fai clic sul link qui sotto e segui le istruzioni per completare il processo.`)
};

const lv_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lai dzēstu savu Brave Premium kontu, klikšķiniet uz saites zemāk un izpildiet norādījumus.`)
};

const lt_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norėdami ištrinti savo „Brave Premium“ paskyrą, spustelėkite toliau pateiktą nuorodą ir vykdykite nurodymus, kad užbaigtumėte procesą.`)
};

const hu_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium fiókjának törléséhez kattintson az alábbi linkre, majd kövesse az utasításokat a folyamat befejezéséhez.`)
};

const nl_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als je je Brave Premium-account wilt verwijderen, klik je op de onderstaande link en volg je de aanwijzingen om het proces te voltooien.`)
};

const nb_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trykk på linken nedenfor og følg veiledningen for å slette Brave Premium-kontoen din.`)
};

const pl_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aby usunąć swoje konto Brave Premium, kliknij poniższy link, a następnie postępuj zgodnie z instrukcjami, aby zakończyć proces.`)
};

const pt_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para excluir sua conta Brave Premium, clique no link abaixo e siga as instruções para concluir o processo.`)
};

const ro_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pentru a șterge contul Brave Premium, dă click pe link-ul de mai jos și apoi urmează instrucțiunile pentru a finaliza procesul.`)
};

const sk_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ak chcete odstrániť svoj účet Brave Premium, kliknite na odkaz nižšie a potom postupujte podľa pokynov.`)
};

const sl_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Če želite izbrisati račun Brave Premium, kliknite spodnjo povezavo in sledite navodilom za dokončanje postopka.`)
};

const fi_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jos haluat poistaa Brave Premium -tilisi, napsauta alla olevaa linkkiä ja noudata ohjeita prosessin suorittamiseksi.`)
};

const sv_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om du vill radera ditt Brave Premium-konto klickar du på länken nedan och följer sedan anvisningarna för att slutföra processen.`)
};

const vi_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để xóa tài khoản Brave Premium của bạn, hãy bấm vào liên kết bên dưới và làm theo các hướng dẫn để hoàn tất quy trình.`)
};

const tr_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium hesabınızı silmek için aşağıdaki bağlantıya tıklayın ve ardından işlemi tamamlamak için yönergeleri izleyin.`)
};

const el_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Για να διαγράψετε τον λογαριασμό σας Brave Premium, κάντε κλικ στον παρακάτω σύνδεσμο και, στη συνέχεια, ακολουθήστε τις οδηγίες για να ολοκληρώσετε τη διαδικασία.`)
};

const bg_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За да изтриеш акаунта си в Brave Premium, кликни върху линка по-долу и следвай указанията, за да завършиш процеса.`)
};

const ru_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чтобы удалить аккаунт Brave Premium, перейдите по ссылке ниже и следуйте инструкциям для завершения процесса.`)
};

const sr_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да бисте избрисали свој Brave Premium налог, кликните на линк у наставку, а затим пратите упутства да бисте завршили поступак.`)
};

const uk_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щоб видалити свій акаунт Brave Premium, натисніть на посилання нижче, а потім дотримуйтесь підказок, щоб завершити процес.`)
};

const ka_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენი Brave Premium ანგარიშის წასაშლელად, დააწკაპუნეთ ქვემოთ მოცემულ ბმულზე და შემდეგ მიჰყევით ინსტრუქციას პროცესის დასასრულებლად.`)
};

const hi_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना ब्रेव प्रीमियम अकाउंट डिलीट करने के लिए, नीचे दिए गए लिंक पर क्लिक करें और फिर प्रोसेस को पूरा करने के लिए संकेतों का पालन करें।`)
};

const th_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หากต้องการลบบัญชี Brave Premium ของคุณ ให้คลิกที่ลิงก์ด้านล่าง จากนั้นทำตามคำแนะนำเพื่อดำเนินการให้เสร็จสมบูรณ์`)
};

const ko_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 프리미엄 계정을 삭제하려면 아래 링크를 클릭한 다음 안내에 따라 절차를 완료하세요.`)
};

const zh_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如要删除您的 Brave Premium 账户，请点击下方的链接，然后按照提示完成删除流程。`)
};

const zh_tw_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`若要刪除您的 Brave 高級版帳戶，請點擊下方連結，並按照提示完成操作流程。`)
};

const ja_delete_account_description = /** @type {(inputs: Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premiumアカウントを削除するには、以下のリンクをクリックし、プロンプトに従って手続きを完了してください。`)
};

/**
* | output |
* | --- |
* | "To delete your Brave Premium account, click the link below and then follow the prompts to complete the process." |
*
* @param {Delete_Account_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const delete_account_description = /** @type {((inputs?: Delete_Account_DescriptionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_DescriptionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_delete_account_description(inputs)
	if (locale === "ms") return ms_delete_account_description(inputs)
	if (locale === "ca") return ca_delete_account_description(inputs)
	if (locale === "cs") return cs_delete_account_description(inputs)
	if (locale === "da") return da_delete_account_description(inputs)
	if (locale === "de") return de_delete_account_description(inputs)
	if (locale === "et") return et_delete_account_description(inputs)
	if (locale === "es") return es_delete_account_description(inputs)
	if (locale === "fr") return fr_delete_account_description(inputs)
	if (locale === "hr") return hr_delete_account_description(inputs)
	if (locale === "it") return it_delete_account_description(inputs)
	if (locale === "lv") return lv_delete_account_description(inputs)
	if (locale === "lt") return lt_delete_account_description(inputs)
	if (locale === "hu") return hu_delete_account_description(inputs)
	if (locale === "nl") return nl_delete_account_description(inputs)
	if (locale === "nb") return nb_delete_account_description(inputs)
	if (locale === "pl") return pl_delete_account_description(inputs)
	if (locale === "pt") return pt_delete_account_description(inputs)
	if (locale === "ro") return ro_delete_account_description(inputs)
	if (locale === "sk") return sk_delete_account_description(inputs)
	if (locale === "sl") return sl_delete_account_description(inputs)
	if (locale === "fi") return fi_delete_account_description(inputs)
	if (locale === "sv") return sv_delete_account_description(inputs)
	if (locale === "vi") return vi_delete_account_description(inputs)
	if (locale === "tr") return tr_delete_account_description(inputs)
	if (locale === "el") return el_delete_account_description(inputs)
	if (locale === "bg") return bg_delete_account_description(inputs)
	if (locale === "ru") return ru_delete_account_description(inputs)
	if (locale === "sr") return sr_delete_account_description(inputs)
	if (locale === "uk") return uk_delete_account_description(inputs)
	if (locale === "ka") return ka_delete_account_description(inputs)
	if (locale === "hi") return hi_delete_account_description(inputs)
	if (locale === "th") return th_delete_account_description(inputs)
	if (locale === "ko") return ko_delete_account_description(inputs)
	if (locale === "zh") return zh_delete_account_description(inputs)
	if (locale === "zh-tw") return zh_tw_delete_account_description(inputs)
	if (locale === "ja") return ja_delete_account_description(inputs)
	return en_delete_account_description(inputs)
});